Cm.social = {
    init: function() {
        const features = 'width=600,height=600';

        $('.facebook-share-button').on('click', () => {
            const url = $('.facebook-share-button').data('href');

            window.open(
                `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                'facebook-share-dialog',
                features
            );
        });

        $('.twitter-share-button').on('click', () => {
            const url = $('.twitter-share-button').data('href');
            const text = $('.twitter-share-button').data('text');

            window.open(
                `https://twitter.com/intent/tweet?text=${text} ${url} via @${wp.site_info.name_nospace}`,
                'twitter-share-dialog',
                features
            );
        });

        $('.pinterest-share-button').on('click', () => {
            const url = $('.pinterest-share-button').data('href');
            const text = $('.pinterest-share-button').data('text');
            const media = $('.pinterest-share-button').data('media');

            window.open(
                `http://pinterest.com/pin/create/button?u=${url}&description=${text}&media=${media}`,
                'pinterest-share-dialog',
                features
            );
        });
    }
}